import { absolutePath } from "@/react/helpers/urlHelpers/internalApi/absolutePath";

export const moderationSettings = {
  show: () => absolutePath("moderation_settings"),
  update: () => absolutePath("moderation_settings"),
};
